
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 494.42 587.6"
    >
      <g fill={theme.palette.primary.main}>
        <path d="m478.42,126.81L264.6,4.25c-9.87-5.65-22.13-5.66-32-.01L16.03,128.1c-9.89,5.65-16.03,16.2-16.03,27.52v26.54l429.66,245.72-181.1,103.56L0,389.48v42.68c0,11.33,6.15,21.88,16.04,27.53l216.58,123.7c4.93,2.81,10.45,4.22,15.97,4.22s11.06-1.41,15.99-4.23l213.82-122.28c9.89-5.66,16.03-16.2,16.03-27.52v-29.69L67.52,159.72,248.58,56.16l245.84,140.9v-42.75c0-11.31-6.13-21.85-16-27.51Z"/>
        <polygon points="247.53 458.5 248.73 459.19 248.73 397.5 1.2 254.4 1.2 254.41 0 253.71 0 315.34 247.53 458.5 247.53 458.5"/>
        <polygon points="248.69 192.06 494.42 333.38 494.42 271.96 248.69 130.18 248.69 192.06"/>
      </g>
    </svg>
  );
};
